import "date-fns";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.js";
import ChartSendAndCollect from "components/Chart/ChartSendAndCollect.js";
import Grid from '@material-ui/core/Grid';
import { getOrdersbyStatus } from "../../services/orders/orders";
import CircularProgress from "../Circular/Circular";
import ExportCsv from "exportCsv.js";
import MomentUtils from "@date-io/date-fns";
import pt from "date-fns/locale/pt";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';

import '../Slots/style.css';

const useStyles = (theme) => ({
  iconView: {
    color: "gray !important",
  },
  root: {
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      margin: theme.spacing(1),
      width: 250,
      height: 200,
    },
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
  },
});

class SendAndCollect extends Component {
  constructor(props) {
    super(props);
    this.getOrders = this.getOrders.bind(this);
    this.handleDateChangeInit = this.handleDateChangeInit.bind(this);
    this.handleDateChangeFinal = this.handleDateChangeFinal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getMinMax = this.getMinMax.bind(this);
    this.handleChangePeriod = this.handleChangePeriod.bind(this);

    this.state = {
      selectedDateInital: null,
      selectedDateFinal: null,
      data: [],
      circular: true,
      chartData: [],
      dataExport: [],
      selectedPeriod: 1,
      somaEntregas: 0,
      somaRetiradas: 0,
      period: [
        {
          value: 1,
          label: "Todo",
        },
        {
          value: 2,
          label: "6h às 22h",
        }
      ]
    };
  }

  componentDidMount() {
    this.getOrders();
  }

  handleDateChangeInit(selectedDateInital) {
    this.setState({ selectedDateInital });
  }

  handleDateChangeFinal(selectedDateFinal) {
    this.setState({ selectedDateFinal });
  }

  handleChange = (size) => {
    this.setState({ size: size.target.value });
  };

  handleChangePeriod = (event) => {
    this.setState({ selectedPeriod: event.target.value }, () => this.getOrders());
  }

  handleExport = () => {
    const { dataExport } = this.state;
    ExportCsv(dataExport);
  };

  handleSearch = () => {
    this.setState({ circular: true });
    this.getOrders();
  };

  getOrders = () => {
    let data = [];
    let chartData = [];
    let dataExport = [];

    let { selectedDateFinal, selectedDateInital, selectedPeriod } = this.state;

    selectedDateInital = selectedDateInital ? new Date(selectedDateInital).setHours(0, 0, 0, 0) : new Date().setHours(0, 0, 0, 0);
    selectedDateFinal = selectedDateFinal ? new Date(selectedDateFinal).setHours(23, 59, 0, 0) : new Date().setHours(23, 59, 0, 0);
    getOrdersbyStatus(this.props.lockerId, 'allocated&status=collected&status=allocatedClient&status=courrier_collected', (order) => {

      order = order.filter(o => o.collectedAt ? selectedDateInital <= new Date(o.collectedAt).getTime() && new Date(o.collectedAt).getTime() <= selectedDateFinal : true);
      order = order.filter(o => o.allocatedAt ? selectedDateInital <= new Date(o.allocatedAt).getTime() && new Date(o.allocatedAt).getTime() <= selectedDateFinal : false);

      let firstHour;
      let lastHour;

      switch (selectedPeriod) {
        case 1:
          firstHour = 0;
          lastHour = 23;
          break;
        case 2:
          firstHour = 6;
          lastHour = 22;
          break;
      }


      let somaEntregas = 0;
      let somaRetiradas = 0;
      for (var i = firstHour; i <= lastHour; i++) {

        let minMax = this.getMinMax(order, `${i}`);

        somaEntregas = somaEntregas + minMax.send;
        somaRetiradas = somaRetiradas + minMax.collect;

        data.push([`${i}:00`, `${minMax.send}`, `${minMax.collect}`]);

        dataExport.push({ Hora: `${i}:00`, 'Entregas': `${minMax.send}`, 'Retiradas': `${minMax.collect}` })
        chartData.push({ year: `${i}:00`, min: minMax.send, max: minMax.collect })
      }

      data.push(['TOTAL', somaEntregas, somaRetiradas]);

      this.setState({ circular: false, data, chartData, dataExport, somaEntregas, somaRetiradas });
    });
  }

  getMinMax = (order, hour) => {

    let filteredOrdersCollect = order.filter(o => (o.collectedAt) ? new Date(o.collectedAt).getHours() === Number(hour) : false);
    filteredOrdersCollect = filteredOrdersCollect.length;

    let filteredOrdersSend = order.filter(o => (o.allocatedAt) ? new Date(o.allocatedAt).getHours() === Number(hour) : false);
    filteredOrdersSend = filteredOrdersSend.length;

    return {
      send: filteredOrdersSend,
      collect: filteredOrdersCollect
    }
  }

  render() {
    const { classes } = this.props;
    const { selectedDateInital, selectedDateFinal, data, circular, chartData, period, selectedPeriod, somaEntregas, somaRetiradas } = this.state;

    let layout = (circular) ?
      <div className={classes.root}>
        <CircularProgress />
      </div>
      : <div>
        <h5>ENTREGAS E RETIRADAS</h5>
        <div className="occupancy-top">
          <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
            <Grid container justify="space-around">
              <KeyboardDatePicker
                locale="pt"
                variant="inline"
                format="dd/MM/yyyy"
                label="Data Inicial"
                value={selectedDateInital}
                onChange={this.handleDateChangeInit}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
            <Grid container justify="space-around">
              <KeyboardDatePicker
                locale="pt"
                variant="inline"
                format="dd/MM/yyyy"
                label="Data Final"
                value={selectedDateFinal}
                onChange={this.handleDateChangeFinal}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <TextField
            className={classes.green}
            id="outlined-hour-input"
            label="Período do dia"
            select
            value={selectedPeriod}
            onChange={this.handleChangePeriod}
          >
            {period.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <Button onClick={this.handleSearch} color="primary">
            Pesquisar
          </Button>
          <Button onClick={this.handleExport} color="default">
            Exportar
          </Button>
        </div>
        <div className="sendAndCollect">
          <Table
            tableHeaderColor="primary"
            tableHead={["Hora", "Entregas", "Retiradas"]}
            tableData={data}

          />
          <div className="char-area">
            <ChartSendAndCollect info={chartData} />
          </div>
        </div>
      </div>;

    return (
      <div>
        {layout}
      </div>
    );
  }
}
export default withStyles(useStyles)(SendAndCollect);
